import "./history.css";
import { DataGrid } from "@material-ui/data-grid";
import {
    Close,
    LocalGroceryStore,
    CloudDownload,
    Comment,
} from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHistory, voidOrder } from "../../redux/apiCalls";
import moment from "moment";
import Select from "react-select";
import { publicRequest } from "../../requestMethods";
import createCustomerInvoice from "../../components/pdf/createCustomerInvoice";
import Table from "../../components/advancedTable";
import { FiFile, FiPlus } from "react-icons/fi";

export default function WarrantyList() {
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    const dispatch = useDispatch();
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin : null
    );
    const orders = useSelector((state) => state.order.order);
    const currentUser = useSelector((state) => state.user.currentUser);

    const marketing = useSelector((state) =>
    state.user.currentUser
        ? state.user.currentUser.type === "marketing"
        : null
);

    const manager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "manager"
            : null
    );

    const principle = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "principle"
            : null
    );

    const outright = useSelector((state) =>
        state.user.currentUser


            ? state.user.currentUser.type === "outright"
            : null
    );

    const accountant = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "accountant"
            : null
    );

    const [inputs, setInputs] = useState({
        cashier: superadmin ? undefined : outright ? currentUser?._id : undefined,
        salesperson: superadmin ? undefined : outright ? undefined :  currentUser?._id,
        user: superadmin || manager || accountant || marketing ? undefined : currentUser._id,
        limit: 20,
        page: 1,
    });
    const [statusMenu, setStatusMenu] = useState(false);
    const [voidMenu, setVoidMenu] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [historyData, setHistoryData] = useState([]);
    const [historyResponse, setHistoryResponse] = useState(null);
    const [coNumber, setCoNumber] = useState(undefined);
    const [selectedRemarks, setSelectedRemarks] = useState("");
    const [remarksMenu, setRemarksMenu] = useState(false);

    useEffect(() => {
        async function fetchData() {
          const result = await getHistory(dispatch, inputs);
          
          setHistoryResponse(result);
          setHistoryData(result?.payload || []);
        }
        
        fetchData();
      }, [dispatch, inputs]);
      

    useEffect(() => {
        if (usersData[0] === undefined) {
            getUsers();
        }
    }, [usersData]);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleInputCoNumber(coNumber);
        }, 1000);

        return () => {
            clearTimeout(timer);
        };
    }, [coNumber]);

    useEffect(() => {
        if (statusMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [statusMenu]);

    const handleVoid = (id) => {
        voidOrder(id, dispatch);
    };

    const handleUserFilter = (e) => {
        setInputs((prev) => {
            return { ...prev, user: e.value };
        });
    };

    const handleInputCoNumber = (e) => {
        setInputs((prev) => {
            return { ...prev, coNumber: e };
        });
    };

    const handleDelayedCoNumberChange = (e) => {
        setCoNumber(e.target.value);
    };

    const fetchOrders = async (dispatch, inputs) => {
        const result = await getHistory(dispatch, inputs);
        setHistoryResponse(result);
        setHistoryData(result?.payload || []);
    };

    const getUsers = async () => {
        const res = await publicRequest.get("/users/all", {
            params: {},
        });
        setUsersData(res.data);
    };

    const modernColumns = [
        {
            Header: "Proof of Payment",
            accessor: "paymentproof",
            Cell: ({ row: { original }, value }) => (
                <div className="flex justify-center cursor-pointer">
                    <div
                        className="cursor-pointer mr-2"
                        onClick={async () => {
                            setModalData({
                                ...original,
                            });
                            // setGalleryModalState(true);
                        }}
                    >
                        <FiPlus />
                    </div>
                    {value ? (
                        <>
                            <FiFile
                                onClick={() => {
                                    window.open(value, "_blank"); // Open image in a new tab if clicked
                                }}
                            ></FiFile>
                        </>
                    ) : (
                        <></>
                    )}
                </div>
            ),
        },
        {
            accessor: "createdAt",
            Header: "Purchase Date",
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {" "}
                    {moment(value).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            accessor: "product",
            Header: "Products",
            sortable: false,
            Cell: (params) => {
                return (
                    <>
                        <LocalGroceryStore
                            className="icon mr-2"
                            onClick={() => {
                                setModalData(params.row.original.products);
                                setStatusMenu(true);
                            }}
                        />
                    </>
                );
            },
        },
        {
            accessor: "invoiceId",
            Header: "Invoice",
            sortable: false,
            Cell: ({ value }) => {
                return <div className="initialPadding">{value}</div>;
            },
        },
        {
            accessor: "coNumber",
            Header: "CONumber",
            sortable: false,
            Cell: ({ value }) => <div className="initialPadding">{value}</div>,
        },
        {
            accessor: "userId",
            Header: "Customer",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "referral",
            Header: "Referral",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "deposit",
            Header: "Paid Amount",
            sortable: false,
            Cell: ({ value, row }) => (
                <div className="initialPadding">
                    {row.original.status === "installment" ? (
                        `RM ${value ? formatter.format(value) : "0"}`
                    ) : (
                        `RM ${row.original.invoicePaid ? formatter.format(row.original.invoicePaid) : "0"}`
                    )}
                </div>
            ),
        },
        {
            accessor: "discount",
            Header: "Discount", 
            sortable: false,
            Cell: ({ value, row }) => (
                <div className="initialPadding">
                    {row.original.status === "installment" ? (
                        `RM ${value ? formatter.format(value) : "0"}`
                    ) : (
                        `RM ${row.original.invoiceDiscount ? formatter.format(row.original.invoiceDiscount) : "0"}`
                    )}
                </div>
            ),
        },
        {
            accessor: "amount", 
            Header: "Total Amount",
            sortable: false,
            Cell: ({ value, row }) => (
                <div className="initialPadding">
                    {row.original.status === "installment" ? (
                        "-"
                    ) : (
                        `RM ${value ? formatter.format(value) : "0"}`
                    )}
                </div>
            ),
        },
        {
            accessor: "paidTotal", 
            Header: "Total Paid",
            sortable: false,
            Cell: ({ value, row }) => (
                <div className="initialPadding">
                    {row.original.status === "installment" ? (
                        "-"
                    ) : (
                        `RM ${formatter.format(row.original.deposit || 0)}`
                    )}
                </div>
            ),
        },
        {
            accessor: "remainingAmount", 
            Header: "Remaining Amount",
            sortable: false,
            Cell: ({ value, row }) => (
                <div className="initialPadding">
                    {row.original.status === "installment" ? (
                        "-"
                    ) : (
                        `RM ${formatter.format((row.original.amount || 0) - (row.original.deposit || 0))}`
                    )}
                </div>
            ),
        },
        {
            accessor: "salesperson",
            Header: "Salesperson",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "cashier",
            Header: "Outlet",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "paymentType",
            Header: "Payment Type",
            sortable: false,
            Cell: ({ value }) => <div className="capitalize">{value}</div>,
        },
        {
            accessor: "remark",
            Header: "Remarks",
            sortable: false,
            Cell: ({ value }) =>
                value ? (
                    <div className="flex items-center">
                        <Comment
                            className="pointer icon"
                            onClick={() => {
                                setSelectedRemarks(value);
                                setRemarksMenu(true);
                            }}
                        />
                    </div>
                ) : (
                    <div></div>
                ),
        },
        {
            accessor: "status",
            Header: "Status",
            sortable: false,
            Cell: ({ value }) => <div className="capitalize">{value}</div>,
        },
    ];

    const productColumns = [
        {
            accessor: "code",
            Header: "Name",
            sortable: false,
            Cell: ({ value }) => <div className="initialPadding">{value}</div>,
        },
        {
            accessor: "quantity",
            Header: "Quantity",
            sortable: false,
            Cell: ({ value }) => <div className="initialPadding">{value}</div>,
        },
        {
            accessor: "price",
            Header: "Unit Price",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">
                    RM {value ? formatter.format(value) : "0"}
                </div>
            ),
        },
        {
            accessor: "amount",
            Header: "Total Price",
            sortable: false,
            Cell: (params) => (
                <div className="initialPadding">
                    RM{" "}
                    {params.row.original.amount
                        ? formatter.format(
                              params.row.original.amount *
                                  params.row.original.price
                          )
                        : "0"}
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="w-full bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen">
                <div className="productList bg-white rounded-3xl shadow-2xl p-8 m-6 border border-slate-200/50">
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-slate-800">Order History</h1>
                        <button
                            onClick={() => window.location.reload()}
                            className="px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center gap-2"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                            Refresh Page
                        </button>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                        <div className="space-y-2">
                            <label className="text-sm font-semibold text-slate-700 tracking-wide">Customer Filter</label>
                            <div className="luxury-select-wrapper">
                                <Select
                                    options={usersData.map((user, i) => {
                                        return {
                                            label: `${user.name} - ${user.phoneNumber}`,
                                            value: user._id,
                                        };
                                    })}
                                    placeholder="Select Customer"
                                    onChange={handleUserFilter}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                            border: '2px solid rgb(226 232 240)',
                                            borderRadius: '12px',
                                            padding: '6px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                borderColor: 'rgb(59 130 246)',
                                            }
                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            backgroundColor: state.isSelected ? 'rgb(59 130 246)' : state.isFocused ? 'rgb(239 246 255)' : 'white',
                                            color: state.isSelected ? 'white' : 'rgb(51 65 85)',
                                            fontWeight: '500',
                                            '&:hover': {
                                                backgroundColor: 'rgb(239 246 255)',
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="space-y-2">
                            <label className="text-sm font-semibold text-slate-700 tracking-wide">CO Number</label>
                            <div className="luxury-select-wrapper">
                                <input
                                    className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                    name="coNumber"
                                    value={coNumber}
                                    type="string"
                                    placeholder="Search by CO Number"
                                    onChange={handleDelayedCoNumberChange}
                                    style={{
                                        background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                        border: '2px solid rgb(226 232 240)',
                                        borderRadius: '12px',
                                        padding: '12px 16px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <Table
                        data={historyData}
                        columns={modernColumns}
                        pageCount={historyResponse && historyResponse.totalPages ? Math.ceil(historyResponse.totalPages / 20) : 1}
                        totalCount={historyResponse && historyResponse.totalPages ? historyResponse.totalPages : 0}
                        updatePagination={setInputs}
                        paginationState={inputs}
                        updateLoaded={() => {}}
                    />
                </div>
            </div>

            {statusMenu && (
                <div className="overlayContainer">
                <div className="bigcenter">
                    <div
                        className="close"
                        onClick={() => setStatusMenu(false)}
                    >
                        <Close></Close>
                    </div>
                    <div className="updatemodalContainer">
                        <div className="updateOrder">
                            <h1 className="updateProductTitle text-xl font-semibold">
                                Products({modalData.length})
                            </h1>
                            <Table
                                data={modalData}
                                columns={productColumns}
                                hidePagination={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
            )}

            {voidMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setVoidMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Confirm Void Order?
                                </h3>
                                <div className="flex justify-center gap-4 mt-6">
                                    <button
                                        className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            handleVoid(modalData);
                                            setVoidMenu(false);
                                        }}
                                    >
                                        Confirm Void
                                    </button>
                                    <button
                                        className="px-6 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            setVoidMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {remarksMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setRemarksMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle text-xl font-semibold mb-4">
                                    Remarks
                                </h3>
                                <div className="p-4 bg-gray-50 rounded-lg mb-6">
                                    <p className="text-gray-700 whitespace-pre-wrap">
                                        {selectedRemarks}
                                    </p>
                                </div>
                                <div className="flex justify-center">
                                    <button
                                        className="px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            setRemarksMenu(false);
                                        }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
